var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-container"},[_c('ul',{staticClass:"list-container__nav"},_vm._l((_vm.navLinks),function(link,id){return _c('li',{key:id},[_c('router-link',{staticClass:"list-container__link",attrs:{"to":{ name: link.to }}},[_vm._v(_vm._s(link.text))]),_c('div',{staticClass:"nav-bar"})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }